export default "__VITE_PUBLIC_ASSET__90c465ea__"